import VueJwtDecode from 'vue-jwt-decode'
import i18n from '@/i18n.js'

const token = $cookies.get('LTI_JWT')
if (token) {
  try {
    let jwtDecoded = VueJwtDecode.decode(token)
    i18n.locale = jwtDecoded.language
  } catch (e) {
    i18n.locale = 'es'
  }
} else {
  i18n.locale = 'es'
}

export default {
  methods: {
    /**
     * Método que formatea una duración en formato hh:mm:ss
     */
    msToTime (s) {
      let ms = s % 1000
      s = (s - ms) / 1000
      let secs = s % 60
      s = (s - secs) / 60
      let mins = s % 60
      let hrs = (s - mins) / 60

      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs)
    },
    /**
     * Método que formatea una duración en formato hh:mm:ss
     */
    sToTime (s) {
      let secs = s % 60
      s = (s - secs) / 60
      let mins = s % 60
      let hrs = (s - mins) / 60

      return this.pad(hrs) + ':' + this.pad(mins) + ':' + this.pad(secs)
    },
    /**
     * Método que formatea una duración en formato hh:mm o mm:ss
     */
    msToTimeRecordings (s) {
      let ms = s % 1000
      s = (s - ms) / 1000
      let secs = s % 60
      s = (s - secs) / 60
      let mins = s % 60
      let hrs = (s - mins) / 60
      if (hrs > 0) {
        return this.pad(hrs) + ':' + this.pad(mins) + 'h'
      } else {
        return this.pad(mins) + ':' + this.pad(secs) + 'm'
      }
    },
    validateTimeString (s) {
      const re = /^([01]\d|2[0-3]):([0-5]\d):([0-5]\d)$/
      return (s === '') || (s === '0') || re.test(s)
    },
    timeToS (t) {
      if (t === '' || t === '0') {
        return 0
      }
      let tokens = t.split(':')
      return parseInt(tokens[0]) * 3600 + parseInt(tokens[1]) * 60 + parseInt(tokens[2])
    },
    pad (n, z) {
      z = z || 2
      return ('00' + n).slice(-z)
    },
    /**
     * Método que da formato a un número de PIN de conexión telefónica
     */
    formatPIN (phonePIN) {
      let t = ' '
      let n = 3
      let s = phonePIN.toString().match(new RegExp('.{1,' + n + '}', 'g'))
      if (s) {
        let o = s[s.length - 1]
        if (s.length > 1 && o.length < n && (s[s.length - 2] += s.pop())) {
          return s.join(t)
        }
      }
    },
    /**
     * Función que determina si una sesíon está en curso
     */
    isOngoing (classroom) {
      let now = window.moment().utc()
      return classroom.active &&
          window.moment(classroom.start).isBefore(now) &&
          (!classroom.end || window.moment(classroom.end).isAfter(now))
    },
    /**
     * Función que determina si una sesíon está en curso desde los X minutos previos
     */
    isOngoingBeforeX (classroom, x) {
      let now = window.moment().utc()
      return classroom.active &&
          window.moment(classroom.start).subtract(x, 'minutes').isBefore(now) &&
          (!classroom.end || window.moment(classroom.end).isAfter(now))
    },
    /**
     * Funcíon que determina si una sesíon aún no ha comenzado
     */
    notYetStarted (classroom) {
      let now = new Date()
      return window.moment(classroom.start).isAfter(now)
    },
    /**
     * Funcíon que determina si una sesíon ha finalizado
     */
    hasEnded (classroom) {
      return !this.isOngoing(classroom) && !this.notYetStarted(classroom)
    },
    /**
     * Método que traduce un rol de aplicación en rol textual visible para usuario
     */
    friendlyRole (systemRole) {
      if (systemRole === 'MODERATOR') {
        return i18n.t('sessions.reports.systemrole.moderator')
      } else if (systemRole === 'PRESENTER') {
        return i18n.t('sessions.reports.systemrole.presenter')
      } else {
        return i18n.t('sessions.reports.systemrole.participant')
      }
    },
    /**
     * Método que genera una cadena alfanumérica aleatoria de una longitud determinada
     */
    randomString (length) {
      let chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
      let result = ''
      for (let i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)]
      return result
    },
    /**
     * Método que devuelve las opciones de paginación (ítems por página)
     */
    paginationOptions () {
      return [10, 20, 50, 100]
    },
    /**
     * Método que devuelve el valor por defecto para el número de ítems por página
     */
    defaultPagination () {
      return 10
    },
    /**
     * Método que devuelve las opciones de paginación (ítems por página)
     */
    targetSystemOptions () {
      return [
        {value: null, text: i18n.t('sessions.selectsystem')},
        {value: 'COLLAB', text: 'Collaborate'},
        {value: 'CONNECT', text: 'Adobe Connect'},
        {value: 'ZOOM', text: 'Zoom'}
      ]
    },
    /**
     * Método que devuelve las opciones de acceso temprano
     */
    boundaryTimeOptions () {
      return [
        {value: 0, text: i18n.t('sessions.noearlyadmision')},
        {value: 15, text: i18n.t('sessions.earlyadmision15')},
        {value: 30, text: i18n.t('sessions.earlyadmision30')},
        {value: 45, text: i18n.t('sessions.earlyadmision45')},
        {value: 60, text: i18n.t('sessions.earlyadmision60')}
      ]
    },
    /**
     * Método que devuelve el valor por defecto de acceso temprano
     */
    boundaryTimeDefaultOption () {
      return 30
    },
    /**
     * Método que evuelve el número de segundos de salto rápido para el player
     */
    seekPlayerTimeSeconds () {
      return 10
    },
    isStaff (user) {
      if (user.unirType !== 'P') {
        return false
      } else {
        return true
      }
    },
    notNullOrUndefined (value) {
      if (undefined !== value && value != null) {
        return true
      } else {
        return false
      }
    },
    /**
     * Método que devuelve las opciones de sistemas de origen de videos
     */
    fontOptions () {
      return [
        {value: null, text: 'Seleccione una fuente'},
        {value: 'FF Unit', text: 'FF Unit'},
        {value: 'Lato Extended', text: 'Lato Extended'},
        {value: 'OpenSans', text: 'OpenSans'},
        {value: 'Proeduca', text: 'Proeduca'}
      ]
    },
    /**
     * Método que devuelve las opciones de paginación (ítems por página)
     */
    unirTypeOptions () {
      return [
        {value: null, text: 'Seleccione un tipo de usuario'},
        {value: 'S', text: 'Estudiante'},
        {value: 'P', text: 'Staff'}
      ]
    },
    /**
     * Método que devulve las opciones de idiomas para traducir
     */
    languageOptions () {
      return [
        {value: null, text: 'Seleccione idioma'},
        {value: 'en-GB', text: 'Ingles'},
        {value: 'es-ES', text: 'Español'}
      ]
    },
    /**
     * Método que calcula la nota de asistencia en base a si el usuario ha superado el umbral de asistencia
     * definido por la licencia. Si attendanceQualified es true, la nota es 100; en caso contrario, 0.
     */
    calculateGrades (attendanceQualified) {
      const grade = attendanceQualified ? 100 : 0
      return { grade }
    },
    /**
     * Método que calcula el porcentaje de progreso de una grabación a partir de la posición y la
     * duración, ambas en milisegundos. Replica el cálculo del backend en
     * RecordingServiceImpl.findInProgressRecordings para que cliente y servidor no divergan.
     * Devuelve null si la duración no es utilizable, y así quien llama decide el valor de reserva.
     */
    recordingPercentage (positionMs, durationMs) {
      if (!durationMs || durationMs <= 0) return null
      return Math.min(100, Math.max(0, Math.round((positionMs || 0) / durationMs * 100)))
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins/utilitiesMixin.js